export const MenuSetup = [
    {
        Label: 'TopMenu.Form1.CompanyInformation', Icon: 'fa-hand-point-right',
        RouterLink: '/main/hr_setup/company_information', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    },
    {
        Label: 'TopMenu.Form1.CreateEditDepartment', Icon: 'fa-hand-point-right',
        RouterLink: '/main/hr_setup/factory', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    },
    {
        Label: 'TopMenu.Form1.TaoDieuChinhBoPhan', Icon: 'fa-hand-point-right',
        RouterLink: '/main/hr_setup/department', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    },
    {
        Label: 'TopMenu.Form1.CreateEditSection', Icon: 'fa-hand-point-right',
        RouterLink: '/main/hr_setup/section', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    },
    {
        Label: 'TopMenu.Form1.CreateEditTeam', Icon: 'fa-hand-point-right',
        RouterLink: '/main/hr_setup/team', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    },
    {
        Label: 'TopMenu.Form1.CreateEditPositionCategory', Icon: 'fa-hand-point-right',
        RouterLink: '/main/hr_setup/position_category', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    },
    {
        Label: 'TopMenu.Form1.TaoDieuChinhChucDanh', Icon: 'fa-hand-point-right',
        RouterLink: '/main/hr_setup/position', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    },
    {
        Label: 'TopMenu.Form1.CreateEditPosition', Icon: 'fa-hand-point-right',
        RouterLink: '/main/hr_setup/chuc_vu', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    },
    {
        Label: 'TopMenu.Form1.SetupShifts', Icon: 'fa-hand-point-right',
        RouterLink: '/main/hr_setup/shifts_setting', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    },
    {
        Label: 'TopMenu.Form1.CreateEditContract', Icon: 'fa-hand-point-right',
        RouterLink: '/main/hr_setup/contract', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    },
    {
        Label: 'TopMenu.Form1.CreateEditContractFlow', Icon: 'fa-hand-point-right',
        RouterLink: '/main/hr_setup/contract_flow', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    },
    {
        Label: 'TopMenu.Form1.TaoDieuChinhLoaiNghi', Icon: 'fa-hand-point-right',
        RouterLink: '/main/hr_setup/leave_type', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    },
    {
        Label: 'TopMenu.Form1.TaoDieuChinhVungMien', Icon: 'fa-hand-point-right',
        RouterLink: '/main/hr_setup/vung_mien', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    },
    {
        Label: 'TopMenu.Form1.TaoDieuChinhDanhMuc', Icon: 'fa-hand-point-right',
        RouterLink: '/main/hr_setup/category', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    },
    {
        Label: 'TopMenu.Form1.SetUpFollowDate', Icon: 'fa-hand-point-right',
        RouterLink: '/main/hr_setup/setup_follow_date', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    },
    {
        Label: 'TopMenu.Form1.MayChamCong', Icon: 'fa-hand-point-right',
        RouterLink: '/main/hr_setup/finger_scanner', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    },
    {
        Label: 'TopMenu.Form1.TaoDieuChinhLoaiCong', Icon: 'fa-hand-point-right',
        RouterLink: '/main/hr_setup/loai_cong', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    },
    {
        Label: 'TopMenu.Form1.TaoDieuChinhDanhMucLuong', Icon: 'fa-hand-point-right',
        RouterLink: '/main/hr_setup/salary_category', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    },
    {
        Label: 'TopMenu.Form1.HR_Hospital', Icon: 'fa-hand-point-right',
        RouterLink: '/main/hr_setup/hospital', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    },
    {
        Label: 'TopMenu.Form1.JobCodeCategory', Icon: 'fa-hand-point-right',
        RouterLink: '/main/hr_setup/job_code_category', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    },
    {
        Label: 'TopMenu.Form1.HazardCategory', Icon: 'fa-hand-point-right',
        RouterLink: '/main/hr_setup/hazard_category', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    },
    {
        Label: 'TopMenu.Form1.SetupHolidayssheet', Icon: 'fa-hand-point-right',
        RouterLink: '/main/hr_setup/holidays_plan', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    }//,
    // {
    //     Label: 'TopMenu.Form1.ListofUsers', Icon: 'fa-hand-point-right',
    //     RouterLink: '/main/hr_setup/rpt_print_all_receipt', Childs: null, IsChildVisible: false,
    //     GroupName: 'EVERYONE'
    // },
    // {
    //     Label: 'TopMenu.Form1.Register', Icon: 'fa-hand-point-right',
    //     RouterLink: '/main/hr_setup/rpt_print_all_receipt', Childs: null, IsChildVisible: false,
    //     GroupName: 'EVERYONE'
    // }
];
export const MenuEmployeeInformation = [
    {
        Label: 'TopMenu.Form1.CreateEditEmployee', Icon: 'fa-calculator',
        RouterLink: '/main/hr_employee_information/employee_infor', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    },
    {
        Label: 'TopMenu.Form1.EmployeeFamilyInformation', Icon: 'fa-calculator',
        RouterLink: '/main/hr_employee_information/employee_family', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    },
    {
        Label: 'TopMenu.Form1.TransferPosition', Icon: 'fa-hand-point-right',
        RouterLink: '/main/hr_employee_information/transfer_position', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    },
    // {
    //     Label: 'TopMenu.Form1.ChuyenChucVu', Icon: 'fa-hand-point-right',
    //     RouterLink: '/main/hr_employee_information/chuyen_chuc_vu', Childs: null, IsChildVisible: false,
    //     GroupName: 'EVERYONE'
    // },
    {
        Label: 'TopMenu.Form1.TerminationAsignment', Icon: 'fa-hand-point-right',
        RouterLink: '/main/hr_employee_information/termination_assignment', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    },
    {
        Label: 'TopMenu.Form1.Disable', Icon: 'fa-hand-point-right',
        RouterLink: '/main/hr_employee_information/disabled_people', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    },
    {
        Label: 'TopMenu.Form1.Discipline', Icon: 'fa-hand-point-right',
        RouterLink: '/main/hr_employee_information/discipline', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    },
    {
        Label: 'TopMenu.Form1.CapPhatAo', Icon: 'fa-hand-point-right',
        RouterLink: '/main/hr_employee_information/cap_phat_ao', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    },
    {
        Label: 'TopMenu.Form1.TaiKhoanNHNV', Icon: 'fa-hand-point-right',
        RouterLink: '/main/hr_employee_information/bank_account_employee', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    }
];
export const MenuTimeKeeping = [
    {
        Label: 'TopMenu.Form1.MaxOvertime', Icon: 'fa-check-square',
        RouterLink: '/main/hr_timekeeping/max_overtime', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    },
    {
        Label: 'TopMenu.Form1.RoundShift', Icon: 'fa-history',
        RouterLink: '/main/hr_timekeeping/round_shift', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    },
    {
        Label: 'TopMenu.Form1.TimeKeepingData', Icon: 'fa-lock',
        RouterLink: '/main/hr_timekeeping/timekeeping_data', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    },
    {
        Label: 'TopMenu.Form1.GoOut', Icon: 'fa-calculator',
        RouterLink: '/main/hr_timekeeping/go_out', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    },
    {
        Label: 'TopMenu.Form1.WorkingDaySpecial', Icon: 'fa-calculator',
        RouterLink: '/main/hr_timekeeping/working_day_special', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    },
    {
        Label: 'TopMenu.Form1.TimeKeepingDaily', Icon: 'fa-hand-point-right',
        RouterLink: '/main/hr_timekeeping/timekeeping_daily', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    },
    {
        Label: 'TopMenu.Form1.CongBatThuong', Icon: 'fa-hand-point-right',
        RouterLink: '/main/hr_timekeeping/cong_bat_thuong', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    },
    {
        Label: 'TopMenu.Form1.EmpRegisPregnant', Icon: 'fa-hand-point-right',
        RouterLink: '/main/hr_timekeeping/emp_regis_pregnant', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    },
    {
        Label: 'TopMenu.Form1.DangKyNghiSinh', Icon: 'fa-hand-point-right',
        RouterLink: '/main/hr_timekeeping/dang_ky_nghi_phep', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    },
    {
        Label: 'TopMenu.Form1.DangKyPhepTheoGio', Icon: 'fa-hand-point-right',
        RouterLink: '/main/hr_timekeeping/dang_ky_phep_theo_gio', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    },
    {
        Label: 'TopMenu.Form1.DanhSachDangKyDiLam', Icon: 'fa-hand-point-right',
        RouterLink: '/main/hr_timekeeping/work_regis_list', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    },
    {
        Label: 'TopMenu.Form1.TienCom', Icon: 'fa-hand-point-right',
        RouterLink: '/main/hr_timekeeping/eating_fee', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    },
    // {
    //     Label: 'TopMenu.Form1.BaoCaoCong', Icon: 'fa-hand-point-right',
    //     RouterLink: '/main/hr_timekeeping/', Childs: null, IsChildVisible: false,
    //     GroupName: 'EVERYONE'
    // }
];
export const MenuSalaryCalculation = [
    {
        Label: 'TopMenu.Form1.DanhSachNguoiPhuThuoc', Icon: 'fa-hand-point-right',
        RouterLink: '/main/hr_salary_calculation/dependents', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    },
    {
        Label: 'TopMenu.Form1.MucLuong', Icon: 'fa-calculator',
        RouterLink: '/main/hr_salary_calculation/salary_level', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    },
    {
        Label: 'TopMenu.Form1.BacTayNghe', Icon: 'fa-calculator',
        RouterLink: '/main/hr_salary_calculation/worker_level', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    },
    {
        Label: 'TopMenu.Form1.MucLuongNhanVien', Icon: 'fa-hand-point-right',
        RouterLink: '/main/hr_salary_calculation/employee_salary_level', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    },
    {
        Label: 'TopMenu.Form1.BacTayNgheNhanVien', Icon: 'fa-hand-point-right',
        RouterLink: '/main/hr_salary_calculation/employee_worker_level', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    },
    {
        Label: 'TopMenu.Form1.luongcodinh', Icon: 'fa-hand-point-right',
        RouterLink: '/main/hr_salary_calculation/salary_component', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    },
    {
        Label: 'TopMenu.Form1.SalaryComponents', Icon: 'fa-hand-point-right',
        RouterLink: '/main/hr_salary_calculation/salary_component_follow_month', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    },
    {
        Label: 'TopMenu.Form1.CreateEditEmployeeContract', Icon: 'fa-hand-point-right',
        RouterLink: '/main/hr_salary_calculation/contract_list', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    },
    // {
    //     Label: 'TopMenu.Form1.EmpRegisParameter', Icon: 'fa-hand-point-right',
    //     RouterLink: '/main/hr_salary_calculation/regis_parameter', Childs: null, IsChildVisible: false,
    //     GroupName: 'EVERYONE'
    // },
    {
        Label: 'TopMenu.Form1.tinhluong', Icon: 'fa-hand-point-right',
        RouterLink: '/main/hr_salary_calculation/salary_calculation', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    }
];
export const MenuInsurancesAndOther = [
    {
        Label: 'TopMenu.Form1.QuanLySoBHXH', Icon: 'fa-hand-point-right',
        RouterLink: '/main/hr_insurances_and_other/insurance', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    },
    {
        Label: 'TopMenu.Form1.TheBHYT', Icon: 'fa-hand-point-right',
        RouterLink: '/main/hr_insurances_and_other/health_insurance_card', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    },
    {
        Label: 'TopMenu.Form1.BaoCaoBaoHiem', Icon: 'fa-hand-point-right',
        RouterLink: '/main/hr_insurances_and_other/insurance_report', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    },
    {
        Label: 'TopMenu.Form1.RegistSIHI', Icon: 'fa-hand-point-right',
        RouterLink: '/main/hr_insurances_and_other/regis_insurance', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    }
];
